import duckify from '../../tools/duckify';

export const namespace = 'cassie';
export const store = 'imagery';

export const Types = duckify(namespace, store, [
  'PUSH_IMAGE',
  'LOAD_LAYER',
  'PUSH_LAYER',
  'SET_BASELINE',
  'TOGGLE_VISIBILITY',
  'UPDATE_OPACITY',
  'REMOVE_LAYER',
  'GENERATE_TRANSECTS',
  'COMMIT_CHANGE',
  'IMAGE_SELECTION',
  'REQUEST_EXPRESSION',
  'PUSH_IMAGE_URL',
  'REMOVE_ELEMENT',
  'RESTART_ANALYSIS',
  'PERFORM_ANALYSIS',
  'PERFORM_SHORE_R_ANALYSIS',
  'PERFORM_SHORE_R_ANALYSIS_COMMIT',
  'SELECT_SHORELINES_FOR_VIZ',
  'INVALID_TRANSECT_ERROR',
  'RESET',
]);

export const Actions = {
  pushImage: (name, date, missionName) => ({
    type: Types.PUSH_IMAGE,
    payload: { name, date, missionName },
  }),

  pushImageUrl: (name, date, missionName, url, falseColorUrl, imageObject) => ({
    type: Types.PUSH_IMAGE_URL,
    payload: { name, date, missionName, url, falseColorUrl, imageObject },
  }),

  // Retrieves the image represented by the specified layers and adds to the parent.
  // If parent is a String, a parent with be created with that name.
  loadLayer: (layer, parent = '???') => ({
    type: Types.LOAD_LAYER,
    payload: { layer, parent },
  }),

  pushLayer: (layer, parent) => ({
    type: Types.PUSH_LAYER,
    payload: { layer, parent },
  }),

  setBaseline: (coordinates) => ({
    type: Types.SET_BASELINE,
    payload: { coordinates },
  }),

  toggleVisibility: (identifier) => ({
    type: Types.TOGGLE_VISIBILITY,
    payload: { identifier },
  }),

  updateOpacity: (identifier, opacity) => ({
    type: Types.UPDATE_OPACITY,
    payload: { identifier, opacity },
  }),

  removeLayer: (identifier) => ({
    type: Types.REMOVE_LAYER,
    payload: { identifier },
  }),

  generateTransects: (identifier) => ({
    type: Types.GENERATE_TRANSECTS,
    payload: { identifier },
  }),

  imageSelection: () => ({
    type: Types.IMAGE_SELECTION,
  }),

  performAnalysis: (coordinatesBaseline, spacing, extent, selectedImages, threshold) => ({
    type: Types.PERFORM_ANALYSIS,
    payload: {
      coordinatesBaseline,
      spacing,
      extent,
      selectedImages,
      threshold,
    },
  }),

  requestExpression: (parent) => ({
    type: Types.REQUEST_EXPRESSION,
    payload: { parent },
  }),

  invalidTransectError: (message) => ({
    type: Types.INVALID_TRANSECT_ERROR,
    payload: message,
  }),

  commitChange: (layer, data) => ({
    type: Types.COMMIT_CHANGE,
    payload: { layer, data },
  }),

  removeElement: (layer) => ({
    type: Types.REMOVE_ELEMENT,
    payload: { layer },
  }),

  restartAnalysis: () => ({
    type: Types.RESTART_ANALYSIS,
  }),

  performShoreRAnalysis: (coordinatesBaseline, spacing, extent, selectedImages, threshold) => ({
    type: Types.PERFORM_SHORE_R_ANALYSIS,
    payload: {
      coordinatesBaseline,
      spacing,
      extent,
      selectedImages,
      threshold,
    },
  }),

  performShoreRAnalysisCommit: (datesToRemove = []) => ({
    type: Types.PERFORM_SHORE_R_ANALYSIS_COMMIT,
    payload: { datesToRemove },
  }),

  selectShorelinesForViz: () => ({
    type: Types.SELECT_SHORELINES_FOR_VIZ,
  }),

  /**
   * Clears the imagery store (images, imageId and layerId) back to its initial state.
   * Dispatched on module switch so land-cover median-composite layers pushed by the previous
   * module don't leak into the next module's LandCover step.
   */
  reset: () => ({
    type: Types.RESET,
  }),
};

export default Actions;
